<template>
  <div>
    <swiper class="swiper" :options="swiperOption" :style="{ width: swiperWidth }">
      <swiper-slide v-for="(item, index) in imageList" :key="index">
        <a class="content" :href="item.link" target="_blank">
          <img :src="item.url" :style="{ width: imageWidth }">
          <div class="content-detail">
            <p class="context-title" :class="dynamicLang">{{ $t(item.title) }}</p>
            <p class="context-detail" :class="dynamicLang" v-html="$t(item.context)"></p>
          </div>
        </a>
      </swiper-slide>
      <div v-if='isPagination' class="swiper-pagination" slot="pagination">
      </div>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    imageList: {
      type: Array,
      required: true
    },
    swiperWidth: {
      type: String,
      required: true
    },
    imageWidth: {
      type: String,
      required: true
    },
    isPagination: {
      type: Boolean,
      required: false,
      default: false
    },
    swiperOptions: {
      type: Object,
      required: true
    }
  },
  computed: {
    swiperOption: function () {
      return this.swiperOptions
    },
    dynamicLang: function () {
      return this.$i18n.locale + 'Lang'
    }
  },
  methods: {
    isPlLast (index) {
      return (this.$i18n.locale === 'pl') &&
        this.imageList.length - 1 === index
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  position: relative;
  display: block;

  .content-detail {
    position: absolute;
    top: 0;
    height: 100%;
    width: 100%;

    p {
      position: relative;
    }

    .context-title {
      top: 80px;
      left: 180px;
      height: 88px;
      font-size: 40px;
      line-height: 46px;
      width: 276px;
      font-weight: 900;
      color: #ffffff;
    }

    .context-title.jpLang {
      font-size: 0.56rem;
      width: 260px;
      left: 170px;
      top: 100px;
    }

    .context-title.esLang {
      width: 260px;
    }

    .context-title.ruLang {
      width: 260px;
    }

    .context-title.mnLang {
      width: 270px;
    }

    .context-detail {
      top: 156px;
      width: 264.26px;
      font-size: 26px;
      left: 46px;
      color: #ffffff;
      line-height: 38px;
      word-break: normal;

      &.jpLang {
        top: 190px;
        left: 40px;
        font-weight: 300;
        font-size: 30px;
      }
    }
  }
}

.pc_introduction {
  .content {
    position: relative;
    display: block;

    .content-detail {
      position: absolute;
      top: 0;
      height: 100%;
      width: 100%;

      p {
        position: relative;
      }

      .context-title {
        top: 3.3rem;
        left: 0.43rem;
        width: 3.6rem;
        height: 1.7rem;
        font-style: normal;
        font-weight: 700;
        font-size: .5rem;
        line-height: .65rem;
        color: #FFFFFF;
        text-shadow: 0px 0.07rem 0.07rem rgba(0, 0, 0, 0.25), 0px 0.019rem 0.19rem rgba(30, 106, 70, 0.5);

        &.plLang {
          font-size: .5rem;
        }
      }

      .context-title.jpLang {
        top: 3.5rem;
        font-size: .54rem;
        width: 3.27rem;
      }

      .context-title.ptLang {
        font-size: .54rem;
        width: 3.6rem;
      }

      .context-title.esLang {
        font-size: 32px;
        width: 260px
      }

      .context-title.ruLang {
        font-size: 29px;
        width: 260px
      }

      .context-title.mnLang {
        font-size: 28px;
        width: 270px
      }

      .context-detail {
        top: 3.4rem;
        width: 264.26px;
        font-size: 26px;
        left: .43rem;
        color: #ffffff;
        line-height: 38px;
        word-break: normal;

        &.plLang {
          font-size: 20px;
        }

        &.mnLang {
          width: 230px;
          font-size: 20px;
        }

        &.jpLang {
          top: 3.7rem;
          left: .35rem;
          font-weight: 400;
        }

        &.esLang {
          top: 3.2rem;
          width: 230px;
          font-size: 20px;
        }
      }
    }
  }
}
</style>

<style lang='less' scoped>
.swiper {
  transform: translate3d(0, 0, 0);
  overflow: hidden;

  .swiper-wrapper {
    transform: translate3d(0, 0, 0);
  }
}
</style>

<style lang="less">
.swiper-container {
  height: 780px;
  padding-left: 2.5%;
}

.pc_introduction {
  .swiper-container {
    height: 12.8rem;
  }
}

.swiper-container .swiper-slide-active {
  -o-transition: all linear 0.35s;
  transition: all linear 0.35s;
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
}

.swiper-container .swiper-slide-prev,
.swiper-container .swiper-slide-next {
  -webkit-transform: scale(0.95);
  -ms-transform: scale(0.95);
  transform: scale(0.95);
}

.pc_introduction .swiper-container .swiper-slide-next {
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
}

.swiper-pagination .swiper-pagination-bullet {
  margin: -13px 10px !important;
  width: 22px;
  height: 22px;
  background-color: #ffffff;
  opacity: 1;

  &.swiper-pagination-bullet-active {
    background-color: #1f9d56;
    width: 22px;
    height: 22px;
  }
}
</style>
